import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Hero from '../components/Hero'
import Menu from '../components/Menu'
import Block from '../components/Block'
import { NextSeo } from 'next-seo';
import Footer from '../components/Footer'
import "./accounting.css"

export default () =>
  <div id="main-container">
    <NextSeo
      title='会計報告 | PyCon mini Hiroshima 2019'
      description='PyCon mini Hiroshima 2019 の会計報告です。'
      openGraph={{
        title: '会計報告 | PyCon mini Hiroshima 2019',
        description: 'PyCon mini Hiroshima 2019 の会計報告です。'
      }}
    />
    <header>
      <Menu />
    </header>
    <div role='main'>
    <div>
      <h1 className='block'>PyCon mini Hiroshima 2019 会計報告</h1>
    </div>
    
<Block title='PyCon mini Hiroshima 2019 収支決算書' backgroundClass='not-center'>
<div>
  <h3>2019年12月2日現在</h3>
  <h3>会計担当 西本卓也</h3>
  <h4>収入の部</h4>
  <table>
    <thead>
      <tr><th>項目</th><th className="price">金額</th><th>備考</th></tr>
    </thead>
    <tbody>
      <tr><th>繰越金</th><td className="price">¥79,965</td><td>2018年より繰越</td></tr>
      <tr><th>参加費（前払い）</th><td className="price">¥204,000</td><td></td></tr>
      <tr><th>参加費（現地払い）</th><td className="price">¥31,000</td><td></td></tr>
      <tr><th>合計</th><td className="price">¥314,965</td><td /></tr>
    </tbody>
  </table>
  <h4>支出の部</h4>
  <table>
    <thead>
      <tr><th>項目</th><th className="price">金額</th><th>備考</th></tr>
    </thead>
    <tbody>
      <tr><th>旅費交通費</th><td className="price">¥92,168</td><td></td></tr>
      <tr><th>懇親会費</th><td className="price">¥146,000</td><td></td></tr>
      <tr><th>ノベルティ製作費</th><td className="price">¥27,967</td><td></td></tr>
      <tr><th>消耗品費</th><td className="price">¥2,250</td><td /></tr>
      <tr><th>手数料</th><td className="price">¥10,339</td><td /></tr>
      <tr><th>繰越金</th><td className="price">¥36,241</td><td>次回に繰越</td></tr>
      <tr><th>合計</th><td className="price">¥314,965</td><td /></tr>
    </tbody>
  </table>
  <h4>監査</h4>
  <div>
    <p>本報告が適正であることを認めます。</p>
    <p>2019年12月2日</p>
    <p>監査担当 石橋伸介</p>
  </div>
</div>

    </Block>
    </div>

    <Footer/>
  </div>
